import { render, staticRenderFns } from "./store-badge.vue?vue&type=template&id=2dbe0f5b&scoped=true"
import script from "./store-badge.vue?vue&type=script&lang=js"
export * from "./store-badge.vue?vue&type=script&lang=js"
import style0 from "./store-badge.vue?vue&type=style&index=0&id=2dbe0f5b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dbe0f5b",
  null
  
)

export default component.exports